import { render, staticRenderFns } from "./form-reassign-activity.component.vue?vue&type=template&id=3ca73b96&scoped=true&"
import script from "./form-reassign-activity.component.vue?vue&type=script&lang=ts&"
export * from "./form-reassign-activity.component.vue?vue&type=script&lang=ts&"
import style0 from "./form-reassign-activity.component.vue?vue&type=style&index=0&id=3ca73b96&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca73b96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
